import { useEffect, useState } from 'react';
import { Popover, Switch, Tooltip } from 'antd';
import { useSelector } from 'react-redux';

import Image from 'global/Image';
import ShareTradeAttachment from 'features/chat/MainContent/BubbleChat/ShareTradeAttachment';
import { ShareTradeInfo } from 'typings/api/shareTradeChat';
import { selectors as profileSelectors } from 'lib/entities/profile';

import { POPOVER_TITLE, TOOLTIP_TITLE } from './constant';
import {
  PopOverButton,
  PopOverContent,
  ContentHeader,
  HeaderTitleWrapper,
  ContentCard,
} from './styled';

interface PopOverInvestmentProps {
  isSelected: boolean;
  defaultSwitchValue: boolean;
  previewShareTrade: ShareTradeInfo | Record<string, never>;
  isScrolling?: boolean;
  onSwitchChange?(checked: boolean): void;
}

const PopOverInvestment = ({
  isSelected,
  defaultSwitchValue,
  previewShareTrade,
  isScrolling = false,
  onSwitchChange = () => { },
}: PopOverInvestmentProps) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [isSwitchChecked, setIsSwitchChecked] =
    useState<boolean>(defaultSwitchValue);

  const { data: profile } = useSelector(profileSelectors);

  const handleChangeSwitch = (checked: boolean) => {
    setIsSwitchChecked(checked);
    onSwitchChange(checked);
    setVisible(false);
  };

  useEffect(() => {
    setIsSwitchChecked(defaultSwitchValue);
  }, [isSelected, defaultSwitchValue]);

  useEffect(() => {
    if (isScrolling) setVisible(false);
  }, [isScrolling]);

  const popOverText = isSwitchChecked
    ? POPOVER_TITLE.CHECKED
    : POPOVER_TITLE.UNCHECKED;
  const iconSuffix = isSwitchChecked ? '_active' : '';
  const PopOverIcon = {
    height: 14,
    width: 14,
  };

  return (
    <Popover
      trigger={['click', 'contextMenu']}
      placement="bottomLeft"
      destroyTooltipOnHide
      visible={visible}
      onVisibleChange={() => setVisible(!visible)}
      content={() => (
        <PopOverContent>
          <ContentHeader>
            <HeaderTitleWrapper>
              <span>{POPOVER_TITLE.CHECKED}</span>

              <Tooltip
                title={TOOLTIP_TITLE}
                trigger={['click', 'contextMenu']}
                placement="bottom"
                overlayClassName="tooltip-overlay-green"
                destroyTooltipOnHide
                overlayStyle={{ minWidth: 320 }}
                overlayInnerStyle={{ background: '#00ab6b' }}
              >
                <Image src="/icon/info.svg" alt="close" {...PopOverIcon} />
              </Tooltip>
            </HeaderTitleWrapper>

            <Switch
              checked={isSwitchChecked}
              onChange={handleChangeSwitch}
              size="small"
            />
          </ContentHeader>

          <ContentCard>
            <ShareTradeAttachment
              info={previewShareTrade}
              username={profile.username}
              isVerified={false}
              usernameColor="#94B041"
              hidePreviousOrder={false}
              hideUsername={false}
              onPreviousOrderClick={() => { }}
              isPreview
            />
          </ContentCard>
        </PopOverContent>
      )}
    >
      <PopOverButton isActive={isSwitchChecked}>
        <Image src={`/icon/sharetrade/currency${iconSuffix}.svg`} alt="icon" />
        <span>{popOverText}</span>
        <Image src={`/icon/sharetrade/arrow${iconSuffix}.svg`} alt="icon" />
      </PopOverButton>
    </Popover>
  );
};

export default PopOverInvestment;
